import React from 'react'

import styles from './styles.module.css'
import cn from 'classnames'

interface ITooltip {
  readonly message: string
  readonly arrow?: boolean
  readonly align?: 'center' | 'start' | 'end'
}

export function Tooltip({ message, arrow = false, align = 'center' }: ITooltip) {
  return (
    <span
      data-tooltip
      data-testid="tooltip"
      className={cn(styles.tooltip, arrow && styles.arrow, {
        [styles.center]: align === 'center',
        [styles.start]: align === 'start',
        [styles.end]: align === 'end',
      })}
    >
      {message}
    </span>
  )
}
